// extracted by mini-css-extract-plugin
export default {"videoElement":"index_videoElement__kTzH4","loading":"index_loading__ccQwA","error":"index_error__MY8qt"};